const notifications = document.querySelector('#notifications');
    if(notifications !== null){
        const toggleBtn = document.querySelector('#notification_toggle-btn');
        const notificationWindow = document.querySelector('#notifications_window');

        //show hidden modal window
        toggleBtn.addEventListener('click',()=>{
            if(notificationWindow.classList.contains('active')){
                notificationWindow.classList.remove('active')
            }else{
                notificationWindow.classList.add('active')
            }
        })

        //hidden burger menu
        window.addEventListener('click',(event)=>{
            if(notificationWindow.classList.contains('active')) {
                if(event.target.closest('#notifications_window') === null && event.target.id !== 'notification_toggle-btn'){
                    notificationWindow.classList.remove('active')
                }
            }
        })

    }

